import { render, staticRenderFns } from "./walletBalance.vue?vue&type=template&id=38842b04&"
import script from "./walletBalance.vue?vue&type=script&lang=js&"
export * from "./walletBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports